
import { defineComponent } from 'vue'
import { useRouter } from 'vue-router'

import useFtlOrder from '@/modules/FtlOrderModule/composable/useFtlOrder'

import SButton from '@/common/components/SButton/index.vue'
import SendDateTimePeriod from '@/modules/CreateOrder/components/SendDateTimePeriod/index.vue'
import CargoCharacteristics from '@/modules/FtlOrderModule/components/CargoCharacteristics/index.vue'
import CompletedDate from '@/modules/FtlOrderModule/components/CompletedDate/index.vue'
import NewWaypointsForm from '@/modules/FtlOrderModule/components/NewWaypointsForm/index.vue'

const FTL_TYPES = [
    { name: 'Междугородняя доставка', value: 0 },
    { name: 'Международная доставка', value: 1 },
    { name: 'Внутригородская доставка', value: 2 },
]

export default defineComponent({
    components: {
        's-button': SButton,
        'send-date-time-period': SendDateTimePeriod,
        'cargo-characteristics': CargoCharacteristics,
        'completed-date': CompletedDate,
        'new-waypoints-form': NewWaypointsForm,
    },
    setup() {
        const {
            state,
            additional_services_state,
            progress,
            openWaypoints,
            setDateAndTime,
            resetDateAndTime,
            setCharacteristics,
            resetCharacteristics,
            setWaypoints,
            createOrder,
            onTypeChange,
        } = useFtlOrder()

        const router = useRouter()

        const goToHistory = () => {
            router.push('/history')
        }

        return {
            state,
            additional_services_state,
            progress,
            FTL_TYPES,
            setDateAndTime,
            resetDateAndTime,
            setCharacteristics,
            resetCharacteristics,
            setWaypoints,
            createOrder,
            onTypeChange,
            goToHistory,
            openWaypoints,
        }
    },
})
